import React from 'react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2, Calculator, TrendingUp, DollarSign, Target, Home, BarChart3, Zap, RefreshCw } from 'lucide-react';

const Preisoptimierung = () => {
  return (
    <div className="page-container">
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center space-x-2">
              <Target className="h-6 w-6 text-primary" />
              <span className="font-bold text-xl">Daniel Leismann</span>
            </Link>
            <Link to="/"><Button variant="outline" size="sm"><Home className="h-4 w-4 mr-2" />Zurück zur Startseite</Button></Link>
          </div>
        </div>
      </nav>

      <div className="pt-20 pb-4 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900 font-medium">Preisoptimierung</span>
          </div>
        </div>
      </div>

      <section className="hero-section-service">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Banner Image */}
          <div className="mb-8 rounded-xl overflow-hidden" style={{maxHeight: '200px'}}>
            <img 
              src="https://images.pexels.com/photos/590022/pexels-photo-590022.jpeg" 
              alt="Preiskalkulation" 
              className="w-full h-48 object-cover"
            />
          </div>
          
          {/* Content Grid */}
          <div className="grid md:grid-cols-3 gap-8 items-start">
            <div className="md:col-span-2">
              <h1 className="service-page-title">Preisoptimierung & Angebotserstellung – EK/VK-Kalkulation automatisieren</h1>
              <p className="service-page-subtitle">Schluss mit manuellen Excel-Tabellen: Ich automatisiere Ihre EK/VK-Kalkulation, erstelle dynamische Preisformeln und integriere Wettbewerber-Monitoring. Maximale Marge bei optimaler Wettbewerbsfähigkeit.</p>
              <div className="flex flex-col sm:flex-row gap-4 mt-8">
                <Link to="/#kontakt"><Button size="lg" className="cta-button-large">Kostenlose Erstanalyse<ArrowRight className="ml-2 h-5 w-5" /></Button></Link>
              </div>
              <div className="mt-6 flex flex-wrap gap-4 text-sm">
                <div className="flex items-center gap-2"><CheckCircle2 className="h-5 w-5 text-accent" /><span>Höhere Margen</span></div>
                <div className="flex items-center gap-2"><CheckCircle2 className="h-5 w-5 text-accent" /><span>Automatische Preise</span></div>
                <div className="flex items-center gap-2"><CheckCircle2 className="h-5 w-5 text-accent" /><span>Wettbewerbsfähig</span></div>
              </div>
            </div>
            <div className="md:col-span-1">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://customer-assets.emergentagent.com/job_leismann-digital/artifacts/52t5d2l5_daniel_leismann.jpg" 
                  alt="Daniel Leismann" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="section-title text-center mb-12">Preisoptimierungs-Leistungen</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="service-card"><CardContent className="p-6"><div className="service-icon"><Calculator className="h-6 w-6" /></div><h3 className="service-title">EK/VK-Kalkulation</h3><p className="service-description">Automatische Berechnung von Einkaufs- und Verkaufspreisen inkl. aller Kostenfaktoren und Margen.</p></CardContent></Card>
            <Card className="service-card"><CardContent className="p-6"><div className="service-icon"><RefreshCw className="h-6 w-6" /></div><h3 className="service-title">Dynamische Preisanpassung</h3><p className="service-description">Automatische Preisanpassungen basierend auf Wettbewerb, Nachfrage und Lagerbestand.</p></CardContent></Card>
            <Card className="service-card"><CardContent className="p-6"><div className="service-icon"><BarChart3 className="h-6 w-6" /></div><h3 className="service-title">Wettbewerber-Monitoring</h3><p className="service-description">Automatische Überwachung von Konkurrenzpreisen und intelligente Repricing-Strategien.</p></CardContent></Card>
            <Card className="service-card"><CardContent className="p-6"><div className="service-icon"><DollarSign className="h-6 w-6" /></div><h3 className="service-title">Margen-Optimierung</h3><p className="service-description">Analyse der Profitabilität nach Produkt, Kategorie und Kanal für maximale Rentabilität.</p></CardContent></Card>
            <Card className="service-card"><CardContent className="p-6"><div className="service-icon"><Zap className="h-6 w-6" /></div><h3 className="service-title">Preisformeln</h3><p className="service-description">Individuelle Preisformeln mit Berücksichtigung von Versand, Gebühren, Rabatten und Steuern.</p></CardContent></Card>
            <Card className="service-card"><CardContent className="p-6"><div className="service-icon"><TrendingUp className="h-6 w-6" /></div><h3 className="service-title">Angebotserstellung</h3><p className="service-description">Automatisierte Angebotserstellung mit aktuellen Preisen, Verfügbarkeiten und Lieferzeiten.</p></CardContent></Card>
          </div>
        </div>
      </section>

      <section className="visual-section">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="section-title-dark">Typische Margenverbesserung</h2>
          <div className="text-6xl font-bold text-accent my-8">+15%</div>
          <p className="text-xl text-gray-300">Durchschnittliche Margensteigerung durch optimierte Preisformeln und automatisches Repricing.</p>
        </div>
      </section>

      <section className="section-light">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="section-title">Bereit für optimale Preise?</h2>
          <p className="section-subtitle mb-8">Lassen Sie uns Ihre Preiskalkulation professionalisieren und automatisieren.</p>
          <Link to="/#kontakt"><Button size="lg" className="cta-button-large">Jetzt kostenlose Erstanalyse anfragen<ArrowRight className="ml-2 h-5 w-5" /></Button></Link>
        </div>
      </section>

      <footer className="footer"><div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center"><p className="text-sm text-muted-foreground">&copy; {new Date().getFullYear()} Daniel Leismann. Alle Rechte vorbehalten.</p></div></footer>
    </div>
  );
};

export default Preisoptimierung;